window.HelpMeChoose = window.HelpMeChoose || {};

HelpMeChoose.init = function (config) {
  const sectionId = config.sectionId;
  const initialTitle = config.initialTitle || '';
  const initialText = config.initialText || '';
  const resultTitle = config.resultTitle || '';
  const resultSubtitle = config.resultSubtitle || '';

  const root = document.getElementById('help-me-choose-' + sectionId);
  if (!root) return;

  const helpOverlay = root.querySelector('.help-overlay');
  if (!helpOverlay) return;
  if (root.dataset.hmcInitialized === 'true') return;
  root.dataset.hmcInitialized = 'true';

  const helpSection = root;
  const helpQa = root.querySelector('.help-qa');

    const openBtn = root.querySelector('.help-banner-btn');
    const closeBtn = root.querySelector('.close-btn');
    const helpPopup = root.querySelector('.help-popup');
    const nextBtn = root.querySelector('.next-btn');
    const backBtn = root.querySelector('.back-btn');
    const progressBar = root.querySelector('#help-progress .current-step');
    const progressWrapper = root.querySelector('#help-progress');
    const questionList = root.querySelector('#help-question-list');
    const helpResult = root.querySelector('#help-result');
    const discountAfter = root.querySelector('#discount-after');
    const resultProducts = Array.from(root.querySelectorAll('.result-product'));
    const titleEl = root.querySelector('.help-title');
    const textEl = root.querySelector('.help-text');
    const questionData = Array.isArray(window.HelpMeChooseQuestionData) ? window.HelpMeChooseQuestionData : [];
    const productMap = {
      'AquaSense 2': {
        id: '8837446795489',
        shortName: 'AquaSense 2',
      },
      'AquaSense 2 Pro': {
        id: '8753744838881',
        shortName: 'AquaSense 2 Pro',
      },
      'AquaSense 2 Ultra': {
        id: '8841023783137',
        shortName: 'AquaSense 2 Ultra',
      },
      'Sora 10': {
        id: '9425295671521',
        shortName: 'Sora 10',
      },
      'Sora 30': {
        id: '9424720953569',
        shortName: 'Sora 30',
      },
      'Sora 70': {
        id: '9326017315041',
        shortName: 'Sora 70',
      },
      'AquaSense X': {
        id: '9302263726305',
        shortName: 'AquaSense X',
      },
      'AquaSense 2 + iSkim Ultra': {
        id: '9474416672993',
        shortName: 'AquaSense 2 + iSkim Ultra',
      },
      'AquaSense 2 Pro + iSkim Ultra': {
        id: '9477892309217',
        shortName: 'AquaSense 2 Pro + iSkim Ultra',
      },
      'AquaSense 2 Ultra + iSkim Ultra': {
        id: '9477888770273',
        shortName: 'AquaSense 2 Ultra + iSkim Ultra',
      },
      'Sora 30 + iSkim Ultra': {
        id: '9465240355041',
        shortName: 'Sora 30 + iSkim Ultra',
      },
    };
    let questions = [];
    let currentStep = 0;
    let selectedAnswers = [];
    let answerSummary = null;
    let recommendationResult = null;
    let isResultView = false;

    function setButtonLoading(button, isLoading) {
      if (!button) return;

      if (isLoading) {
        button.classList.add('loading');
        button.style.pointerEvents = 'none';
      } else {
        button.classList.remove('loading');
        button.style.pointerEvents = '';
      }
    }

    function syncMiniCartIcons() {
      if (window.BBMiniCartIcons && typeof window.BBMiniCartIcons.sync === 'function') {
        window.BBMiniCartIcons.sync();
        requestAnimationFrame(function () {
          window.BBMiniCartIcons.sync();
        });
      }
    }

    function openMiniCart() {
      const cartElement = document.querySelector('.t4s-site-nav__cart');
      const cartButton = cartElement && cartElement.children ? cartElement.children[0] : null;

      if (cartButton) {
        cartButton.click();
      } else {
        console.error('Unable to find mini cart trigger element');
      }
    }

    function helpApplyDiscountCode(code) {
      if (!code) return Promise.resolve({ ok: true });

      if (typeof applyDiscountCode === 'function') {
        return applyDiscountCode(code);
      }

      return fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
        method: 'GET',
        credentials: 'same-origin',
      }).then(function (response) {
        return { ok: response.ok };
      });
    }

    function helpFallbackAddToCart(productItems, sectionsToUpdate, shouldOpenMiniCart = true, discountCode = '') {
      const addItemPromise = fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: productItems }),
      }).then(function (response) {
        if (!response.ok) {
          throw new Error(`Add to cart failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      });

      const discountPromise = discountCode ? helpApplyDiscountCode(discountCode) : Promise.resolve({ ok: true });

      return addItemPromise
        .then(function () {
          const sectionsPromise = fetch(`/?sections=${sectionsToUpdate}`, {
            method: 'GET',
            headers: { Accept: 'application/json' },
          }).then(function (response) {
            if (!response.ok) throw new Error(`Failed to fetch sections: ${response.status}`);
            return response.json();
          });

          return Promise.all([
            discountPromise.catch(function (error) {
              return { ok: false, error: error };
            }),
            sectionsPromise,
          ]);
        })
        .then(function (results) {
          const sectionsResult = results[1];

          if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Cart) {
            T4SThemeSP.Cart.renderContents(sectionsResult || {});
            syncMiniCartIcons();
          }

          if (shouldOpenMiniCart) {
            openMiniCart();
          }
        });
    }

    function helpAddToCart(productItems, shouldOpenMiniCart = true, discountCode = '') {
      const sectionsToUpdate = 'cart_data,mini_cart';
      const requestBody = {
        updates: productItems.reduce(function (acc, item) {
          acc[item.id] = Number(item.quantity);
          return acc;
        }, {}),
      };

      if (discountCode) {
        requestBody.discount = discountCode;
      }

      return fetch(`/cart/update.js?sections=${sectionsToUpdate}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(`Cart update failed: ${response.status} ${response.statusText}`);
          }
          return response.json();
        })
        .then(function (result) {
          if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Cart) {
            if (result.sections) {
              T4SThemeSP.Cart.renderContents(result.sections);
            } else if (T4SThemeSP.Cart.Cart && typeof T4SThemeSP.Cart.Cart.renderContents === 'function') {
              T4SThemeSP.Cart.Cart.renderContents();
            }
            syncMiniCartIcons();
          }

          if (shouldOpenMiniCart) {
            openMiniCart();
          }
        })
        .catch(function () {
          return helpFallbackAddToCart(productItems, sectionsToUpdate, shouldOpenMiniCart, discountCode);
        });
    }

    function helpAddToCartOriginal(productItems, button, discountCode = '') {
      const sectionsToUpdate = 'cart_data,mini_cart';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: productItems,
        }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(`Add to cart failed: ${response.status} ${response.statusText}`);
          }
          return response.json();
        })
        .then(function () {
          const updateBody = {};

          if (discountCode) {
            updateBody.discount = discountCode;
          }

          return fetch(`/cart/update.js?sections=${sectionsToUpdate}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updateBody),
          });
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(`Cart update failed: ${response.status} ${response.statusText}`);
          }
          return response.json();
        })
        .then(function (result) {
          if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Cart) {
            T4SThemeSP.Cart.renderContents(result.sections || {});
            syncMiniCartIcons();
            openMiniCart();
          }
        })
        .catch(function (error) {
          console.error('help-me-choose add to cart error:', error);
        })
        .finally(function () {
          setButtonLoading(button, false);
        });
    }

    function bindCommerceButtons() {
      root.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const currentProductId = this.dataset.id;
          const discountCode = this.dataset.discountCode || '';
          const items = [{ id: currentProductId, quantity: 1 }];
          const cartCountElement = document.getElementById('cart-count-op');
          const currentCartCount = cartCountElement ? parseInt(cartCountElement.textContent || '0', 10) : 0;

          setButtonLoading(this, true);

          if (currentCartCount === 0) {
            helpAddToCart(items, true, discountCode).finally(() => {
              setButtonLoading(this, false);
            });
          } else {
            helpAddToCartOriginal(items, this, discountCode);
          }
        });
      });

      root.querySelectorAll('.buy-now-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const currentProductId = this.dataset.id;
          const discountCode = this.dataset.discountCode || '';
          const items = [{ id: currentProductId, quantity: 1 }];

          setButtonLoading(this, true);

          fetch('/cart/clear.js', { method: 'POST' })
            .then(function () {
              return helpAddToCart(items, false, discountCode);
            })
            .then(() => {
              setButtonLoading(this, false);
              window.location.href = discountCode
                ? `/checkout?discount=${encodeURIComponent(discountCode)}`
                : '/checkout';
            })
            .catch(() => {
              setButtonLoading(this, false);
              window.location.href = discountCode
                ? `/checkout?discount=${encodeURIComponent(discountCode)}`
                : '/checkout';
            });
        });
      });
    }

    function scrollPopupToTop() {
      if (!helpPopup) return;

      // 用 instant 而非 smooth：切题时立即归位，缩短交互到下一帧绘制的延迟
      helpPopup.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    }

    function copyTextToClipboard(text) {
      if (!text) return Promise.reject(new Error('No discount code to copy'));

      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    }

    function bindDiscountAfterCopy() {
      if (!discountAfter) return;

      const copyButton = discountAfter.querySelector('.d-copy');
      const discountCode = discountAfter.dataset.discountCode || '';

      if (!copyButton || !discountCode) return;

      copyButton.addEventListener('click', function () {
        copyTextToClipboard(discountCode).then(function () {
          copyButton.classList.add('is-copied');
          window.clearTimeout(copyButton._copyResetTimer);
          copyButton._copyResetTimer = window.setTimeout(function () {
            copyButton.classList.remove('is-copied');
          }, 1600);
        });
      });
    }

    function fireDiscountConfetti() {
      if (!discountAfter || !discountAfter.classList.contains('is-visible')) return;

      // 尊重「减少动态效果」偏好，直接跳过粒子动画
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const rect = discountAfter.getBoundingClientRect();
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const pixelRatio = window.devicePixelRatio || 1;
      const colors = ['#0d22e6', '#ff3e2e', '#ffab5c', '#f56d28', '#ffffff'];
      const pieces = Array.from({ length: 90 }, function () {
        const angle = Math.random() * Math.PI * 2;
        const speed = 3 + Math.random() * 6;

        return {
          x: (rect.left + rect.width / 2) * pixelRatio,
          y: (rect.top + rect.height / 2) * pixelRatio,
          vx: Math.cos(angle) * speed * pixelRatio,
          vy: Math.sin(angle) * speed * pixelRatio - 3 * pixelRatio,
          size: (4 + Math.random() * 6) * pixelRatio,
          rotation: Math.random() * Math.PI,
          rotationSpeed: (Math.random() - 0.5) * 0.3,
          color: colors[Math.floor(Math.random() * colors.length)],
          alpha: 1,
        };
      });
      let frame = 0;

      canvas.width = window.innerWidth * pixelRatio;
      canvas.height = window.innerHeight * pixelRatio;
      canvas.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;width:100vw;height:100vh;';
      document.body.appendChild(canvas);

      function animateConfetti() {
        frame += 1;
        context.clearRect(0, 0, canvas.width, canvas.height);

        pieces.forEach(function (piece) {
          piece.x += piece.vx;
          piece.y += piece.vy;
          piece.vy += 0.12 * pixelRatio;
          piece.vx *= 0.985;
          piece.rotation += piece.rotationSpeed;
          piece.alpha = Math.max(0, 1 - frame / 90);

          context.save();
          context.globalAlpha = piece.alpha;
          context.translate(piece.x, piece.y);
          context.rotate(piece.rotation);
          context.fillStyle = piece.color;
          context.fillRect(-piece.size / 2, -piece.size / 2, piece.size, piece.size * 0.55);
          context.restore();
        });

        if (frame < 90) {
          requestAnimationFrame(animateConfetti);
        } else {
          canvas.remove();
        }
      }

      requestAnimationFrame(animateConfetti);
    }

    function revealDiscountAfter(shouldAnimate) {
      if (!discountAfter) return;

      const hasDiscountCode = Boolean(discountAfter.dataset.discountCode);
      if (!hasDiscountCode) return;

      const wasVisible = discountAfter.classList.contains('is-visible');
      const overlayOpen = helpOverlay.classList.contains('is-open');
      const canAnimate = shouldAnimate && overlayOpen && !wasVisible;

      if (!canAnimate) {
        discountAfter.classList.remove('is-hiding');
        discountAfter.classList.add('is-visible');
        if (!wasVisible && overlayOpen) {
          window.setTimeout(fireDiscountConfetti, 220);
        }
        return;
      }

      // 弹窗可见时再触发过渡，避免在 display:none 祖先下预热导致动画失效
      discountAfter.classList.add('is-hiding');
      discountAfter.classList.remove('is-visible');

      requestAnimationFrame(function () {
        discountAfter.classList.remove('is-hiding');
        void discountAfter.offsetHeight;
        requestAnimationFrame(function () {
          discountAfter.classList.add('is-visible');
          window.setTimeout(fireDiscountConfetti, 220);
        });
      });
    }

    function updateDiscountAfterVisibility(shouldAnimate) {
      if (!discountAfter) return;

      const hasDiscountCode = Boolean(discountAfter.dataset.discountCode);
      const shouldShow = isResultView && hasDiscountCode;

      if (shouldShow) {
        revealDiscountAfter(shouldAnimate !== false);
        return;
      }

      discountAfter.classList.add('is-hiding');
      discountAfter.classList.remove('is-visible');
      requestAnimationFrame(function () {
        discountAfter.classList.remove('is-hiding');
      });
    }

    function getSelectedValue(stepIndex) {
      return selectedAnswers[stepIndex];
    }

    function extractOptionLetter(optionId) {
      if (!optionId) return '';

      const matches = String(optionId).match(/-([A-Z])$/i);
      return matches ? matches[1].toUpperCase() : '';
    }

    function hasSelection(stepIndex) {
      const value = getSelectedValue(stepIndex);

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return Boolean(value);
    }

    function buildAnswerSummary() {
      const answersByQuestion = questionData.map(function (question, questionIndex) {
        const rawValue = selectedAnswers[questionIndex];
        const optionIds = Array.isArray(rawValue) ? rawValue.slice() : rawValue ? [rawValue] : [];
        const letters = optionIds.map(extractOptionLetter).filter(Boolean);
        const selectedLabels = optionIds
          .map(function (optionId) {
            const matchedOption = (question.options || []).find(function (option) {
              return option.id === optionId;
            });

            return matchedOption ? matchedOption.text : '';
          })
          .filter(Boolean);

        return {
          questionIndex: questionIndex + 1,
          questionId: question.id,
          questionText: question.question,
          multiSelect: Boolean(question.multiSelect),
          selectedOptionIds: optionIds,
          selectedLetters: letters,
          selectedLabels: selectedLabels,
        };
      });

      const selectedOptionIdsFlat = answersByQuestion.flatMap(function (item) {
        return item.selectedOptionIds;
      });
      const selectedLettersFlat = answersByQuestion.flatMap(function (item) {
        return item.selectedLetters;
      });

      return {
        answersByQuestion: answersByQuestion,
        selectedOptionIdsFlat: selectedOptionIdsFlat,
        selectedLettersFlat: selectedLettersFlat,
        selectedOptionIdsJoined: selectedOptionIdsFlat.join(','),
        selectedLettersJoined: selectedLettersFlat.join(','),
        selectedPath: answersByQuestion
          .map(function (item) {
            return item.selectedLetters.join('');
          })
          .filter(Boolean)
          .join('-'),
      };
    }

    function updateAnswerSummary() {
      answerSummary = buildAnswerSummary();
      window.HelpMeChooseAnswerSummary = answerSummary;

      helpOverlay.dataset.selectedOptionIds = answerSummary.selectedOptionIdsJoined;
      helpOverlay.dataset.selectedLetters = answerSummary.selectedLettersJoined;
      helpOverlay.dataset.selectedPath = answerSummary.selectedPath;
    }

    function reportResultViewToGA() {
      if (!isResultView || !answerSummary) return;
      if (typeof window.gtag !== 'function') return;

      const payload = {
        selected_path: answerSummary.selectedPath,
      };

      answerSummary.answersByQuestion.forEach(function (answer, index) {
        const questionNumber = index + 1;
        payload[`q${questionNumber}_letters`] = answer.selectedLetters.join(',');
        payload[`q${questionNumber}_labels`] = answer.selectedLabels.join('|');
      });

      window.gtag('event', 'help_me_choose_result_view', payload);
    }

    function updateHeaderContent() {
      if (!titleEl || !textEl) return;

      titleEl.textContent = isResultView ? resultTitle || initialTitle || '' : initialTitle || '';
      textEl.textContent = isResultView ? resultSubtitle || initialText || '' : initialText || '';
    }

    function updateResultView(options) {
      if (!helpResult) return;

      const shouldAnimateDiscount = options && options.animateDiscount;

      if (helpQa) {
        helpQa.classList.toggle('is-result-view', isResultView);
      }

      helpResult.classList.toggle('is-visible', isResultView);
      questionList.style.display = isResultView ? 'none' : '';
      progressWrapper.style.display = isResultView ? 'none' : '';

      resultProducts.forEach(function (card) {
        card.classList.remove('is-visible', 'main-rec', 'sub-rec');
        card.style.order = '';
      });

      if (isResultView && recommendationResult) {
        const primaryId = recommendationResult.primaryProduct ? String(recommendationResult.primaryProduct.id) : '';
        const secondaryIds = (recommendationResult.secondaryProducts || []).map(function (product) {
          return String(product.id);
        });

        resultProducts.forEach(function (card) {
          const cardProductId = String(card.dataset.productId || '');

          if (cardProductId === primaryId) {
            card.classList.add('is-visible', 'main-rec');
            card.style.order = '1';
          }

          const secondaryIndex = secondaryIds.indexOf(cardProductId);
          if (secondaryIndex > -1) {
            card.classList.add('is-visible', 'sub-rec');
            card.style.order = String(secondaryIndex + 2);
          }
        });
      }

      updateHeaderContent();
      updateDiscountAfterVisibility(shouldAnimateDiscount);
      updateNavigation();
      reportResultViewToGA();
    }

    function setupResultDescriptionToggles() {
      resultProducts.forEach(function (card) {
        const description = card.querySelector('.result-description');

        if (!description) return;

        const listItems = description.querySelectorAll('li');
        if (listItems.length <= 2) return;

        description.classList.add('is-collapsed');

        const toggleBtn = document.createElement('div');
        toggleBtn.className = 'result-description-toggle is-visible';
        toggleBtn.textContent = 'Learn more ＞';

        toggleBtn.addEventListener('click', function () {
          const isCollapsed = description.classList.toggle('is-collapsed');
          toggleBtn.textContent = isCollapsed ? 'Learn more ＞' : 'Show less ＞';
        });

        description.insertAdjacentElement('afterend', toggleBtn);
      });
    }

    function getQuestionLetters(questionIndex) {
      if (!answerSummary || !answerSummary.answersByQuestion[questionIndex]) return [];
      return answerSummary.answersByQuestion[questionIndex].selectedLetters || [];
    }

    function getSingleQuestionLetter(questionIndex) {
      const letters = getQuestionLetters(questionIndex);
      return letters[0] || '';
    }

    function getRecommendationKeys() {
      const q3Letter = getSingleQuestionLetter(2);
      const q5Letter = getSingleQuestionLetter(4);
      const recommendationMap = {
        A: {
          A: {
            primary: 'AquaSense 2 Pro',
            secondary: ['AquaSense 2 Pro + iSkim Ultra'],
          },
          B: {
            primary: 'AquaSense 2',
            secondary: [],
          },
          C: {
            primary: 'Sora 70',
            secondary: ['Sora 30 + iSkim Ultra'],
          },
          D: {
            primary: 'Sora 10',
            secondary: ['Sora 30'],
          },
        },
        B: {
          A: {
            primary: 'AquaSense 2 Ultra',
            secondary: [],
          },
          B: {
            primary: 'AquaSense 2 Ultra',
            secondary: ['AquaSense 2 Ultra + iSkim Ultra'],
          },
          C: {
            primary: 'Sora 70',
            secondary: ['AquaSense 2 + iSkim Ultra'],
          },
          D: {
            primary: 'Sora 70',
            secondary: ['Sora 30'],
          },
        },
        C: {
          A: {
            primary: 'AquaSense X',
            secondary: [],
          },
          B: {
            primary: 'AquaSense 2 Ultra',
            secondary: ['AquaSense 2 Ultra + iSkim Ultra'],
          },
          C: {
            primary: 'Sora 70',
            secondary: ['AquaSense 2 + iSkim Ultra'],
          },
          D: {
            primary: 'Sora 70',
            secondary: ['AquaSense 2'],
          },
        },
        D: {
          A: {
            primary: 'AquaSense X',
            secondary: [],
          },
          B: {
            primary: 'AquaSense 2 Ultra',
            secondary: ['AquaSense 2 Ultra + iSkim Ultra'],
          },
          C: {
            primary: 'AquaSense 2 Pro',
            secondary: ['AquaSense 2 Pro + iSkim Ultra'],
          },
          D: {
            primary: 'Sora 70',
            secondary: ['AquaSense 2', 'AquaSense 2 + iSkim Ultra'],
          },
        },
      };

      return recommendationMap[q3Letter] && recommendationMap[q3Letter][q5Letter]
        ? recommendationMap[q3Letter][q5Letter]
        : { primary: '', secondary: [] };
    }

    function buildRecommendationResult() {
      const recommendationKeys = getRecommendationKeys();
      const mainProductKey = recommendationKeys.primary;
      const primaryProduct = productMap[mainProductKey] || null;
      const primaryProductId = primaryProduct ? String(primaryProduct.id) : '';
      const secondaryProducts = recommendationKeys.secondary
        .map(function (productKey) {
          return productMap[productKey] || null;
        })
        .filter(function (product, index, array) {
          if (!product) return false;

          const productId = String(product.id);
          return productId && productId !== primaryProductId && array.findIndex(function (item) {
            return item && String(item.id) === productId;
          }) === index;
        });

      return {
        q3Letter: getSingleQuestionLetter(2),
        q5Letter: getSingleQuestionLetter(4),
        mainProductKey: mainProductKey,
        secondaryProductKeys: recommendationKeys.secondary,
        primaryProduct: primaryProduct,
        secondaryProducts: secondaryProducts,
      };
    }

    function printRecommendationIfComplete() {
      const isAllAnswered = questionData.every(function (_, index) {
        return hasSelection(index);
      });

      if (!isAllAnswered) return;

      recommendationResult = buildRecommendationResult();
      window.HelpMeChooseRecommendation = recommendationResult;
    }

    function showResults() {
      printRecommendationIfComplete();

      if (!recommendationResult || !recommendationResult.primaryProduct) return;

      isResultView = true;
      updateResultView({ animateDiscount: true });
      scrollPopupToTop();
    }

    function buildQuestionMarkup(data) {
      return data
        .map(function (question) {
          const optionsMarkup = question.options
            .map(function (option) {
              const optionClass = option.extraClass ? `option ${option.extraClass}` : 'option';

              return `
                <div class="${optionClass}" id="${option.id}">
                  <img
                    src="${option.image}"
                    alt="${option.alt || option.text || ''}"
                    loading="lazy"
                    width="${option.width || ''}"
                    height="${option.height || ''}"
                  >
                  <span>${option.text}</span>
                </div>
              `;
            })
            .join('');

          return `
            <div id="${question.id}" style="display: none;">
              <h3 class="question">${question.question}</h3>
              <div class="question-wrapper">
                ${optionsMarkup}
              </div>
            </div>
          `;
        })
        .join('');
    }

    function bindQuestionEvents() {
      questions.forEach(function (question, questionIndex) {
        const options = question.querySelectorAll('.option');
        const isMultiSelect = Boolean(questionData[questionIndex] && questionData[questionIndex].multiSelect);

        options.forEach(function (option) {
          option.addEventListener('click', function () {
            if (isMultiSelect) {
              const selectedValues = Array.isArray(selectedAnswers[questionIndex])
                ? selectedAnswers[questionIndex]
                : [];
              const optionValue = option.id || `step-${questionIndex + 1}`;
              const valueIndex = selectedValues.indexOf(optionValue);

              if (valueIndex > -1) {
                selectedValues.splice(valueIndex, 1);
                option.classList.remove('selected');
              } else {
                selectedValues.push(optionValue);
                option.classList.add('selected');
              }

              selectedAnswers[questionIndex] = selectedValues.slice();
            } else {
              options.forEach(function (item) {
                item.classList.remove('selected');
              });
              option.classList.add('selected');
              selectedAnswers[questionIndex] = option.id || `step-${questionIndex + 1}`;
            }

            updateAnswerSummary();
            printRecommendationIfComplete();

            if (questionIndex === currentStep) {
              updateNavigation();
            }
          });
        });
      });
    }

    function toggleOverlay(isOpen) {
      helpOverlay.classList.toggle('is-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    }

    function updateProgress() {
      if (!progressBar || !questions.length) return;
      const progress = ((currentStep + 1) / questions.length) * 100;
      progressBar.style.width = `${progress}%`;
    }

    function updateNavigation() {
      if (isResultView) {
        backBtn.classList.remove('is-hidden');
        nextBtn.classList.add('is-hidden');
        nextBtn.classList.remove('is-disabled');
        return;
      }

      nextBtn.classList.remove('is-hidden');
      backBtn.classList.toggle('is-hidden', currentStep === 0);
      nextBtn.classList.toggle('is-disabled', !hasSelection(currentStep));
    }

    function showStep(stepIndex) {
      if (!questions.length) return;

      isResultView = false;
      questions.forEach((question, index) => {
        question.style.display = index === stepIndex ? 'block' : 'none';
      });

      currentStep = stepIndex;
      updateProgress();
      updateResultView();
      updateNavigation();
      scrollPopupToTop();
    }

    if (!questionList || !questionData.length) return;

    // 预热只建 DOM / 绑事件；首屏展示(showStep)等弹窗打开后再做，
    // 避免在 display:none 的 overlay 里触发折扣卡过渡和结果态样式。
    var isQuizInitialized = false;
    var hasPresentedFirstStep = false;

    function initQuizCore() {
      if (isQuizInitialized) return;
      isQuizInitialized = true;

      questionList.innerHTML = buildQuestionMarkup(questionData);
      questions = Array.from(questionList.querySelectorAll('[id^="choose-"]'));
      selectedAnswers = questionData.map(function (question) {
        return question.multiSelect ? [] : null;
      });
      bindQuestionEvents();
      bindCommerceButtons();
      bindDiscountAfterCopy();
      setupResultDescriptionToggles();
      updateAnswerSummary();
    }

    function ensureQuizReady() {
      initQuizCore();

      if (!hasPresentedFirstStep && !isResultView) {
        showStep(0);
        hasPresentedFirstStep = true;
      }
    }

    openBtn.addEventListener('click', function () {
      initQuizCore();
      toggleOverlay(true);
      scrollPopupToTop();

      if (isResultView) {
        updateResultView();
      } else {
        ensureQuizReady();
      }
    });

    closeBtn.addEventListener('click', function () {
      toggleOverlay(false);
    });

    helpOverlay.addEventListener('click', function (event) {
      if (event.target === helpOverlay) {
        toggleOverlay(false);
      }
    });

    backBtn.addEventListener('click', function () {
      if (!isQuizInitialized) return;
      if (isResultView) {
        showStep(questions.length - 1);
        return;
      }

      if (currentStep === 0) return;
      showStep(currentStep - 1);
    });

    nextBtn.addEventListener('click', function () {
      if (!isQuizInitialized) return;
      if (!hasSelection(currentStep)) return;

      if (currentStep >= questions.length - 1) {
        showResults();
        return;
      }

      showStep(currentStep + 1);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && helpOverlay.classList.contains('is-open')) {
        toggleOverlay(false);
      }
    });

    // 空闲预热：把建 DOM / 绑事件挪出关键路径
    var scheduleIdle =
      window.requestIdleCallback ||
      function (cb) {
        return window.setTimeout(function () {
          cb();
        }, 200);
      };
    scheduleIdle(function () {
      initQuizCore();
    });
};
